// @ts-ignore
import _LazyLoadWrapper from "@my-scoot/exly-react-component-lib/build/esm/components/common/LazyLoadWrapper";
import { ILazyLoadWrapper } from "./LazyLoadWrapper.interface";

export const LazyLoadWrapper: ILazyLoadWrapper = _LazyLoadWrapper;
